import { Switch, Redirect, Route } from 'react-router-dom';

// Import utilities
import LoadableMng from 'components/utilities/lodable_manager/LodableMng';

// Import components
import ProtectedUserLogged from 'components/hoc/ProtectedUserLogged';

// Import paths
import { TV_PATHS } from '../tv_routes/paths';
import { MAIN_PATHS } from './paths';
import { AuthPaths } from 'components/routes/auth/routes';
import { redirectPaths } from './redirectPaths';

const Main = LoadableMng({
	func: () => import('components/views/Main')
});

const NotFound = LoadableMng({
	func: () => import('components/views/NotFound')
});

const Static = LoadableMng({
	func: () => import('components/templates/StaticContentTemplate')
});

const ContactSection = LoadableMng({
	func: () => import('components/views/root/contact/ContactSection')
});

const DocumentSection = LoadableMng({
	func: () => import('components/views/root/documents/Documents')
});

const OfferConfigurator = LoadableMng({
	func: () => import('components/views/offer_configurator/OfferConfigurator')
});

const Auth = LoadableMng({
	func: () => import('components/views/auth/Auth')
});

const { MAIN } = TV_PATHS;
const { NOT_FOUND, OFFER_CONFIGURATOR, CONTACT, DOCUMENTS, STATIC } = MAIN_PATHS;

function RetailRoutes() {
	return (
		<Switch>
			<Route path={STATIC} component={Static} />
			{redirectPaths.map(({ from, to }) => (
				<Redirect key={from} exact from={from} to={to} />
			))}
			<ProtectedUserLogged path={AuthPaths.Default} component={Auth} />
			<Route path={CONTACT} component={ContactSection} />
			<Route path={OFFER_CONFIGURATOR} component={OfferConfigurator} />
			<Route path={DOCUMENTS} component={DocumentSection} />
			<Route path={NOT_FOUND} component={NotFound} />
			<Main />
			<Redirect to={MAIN} />
		</Switch>
	);
}

export default RetailRoutes;
